import type { TopBannerMessage } from '../types/TopBannerMessage';
import type { GlobalNavigationContentEntry } from './contentstackGraphQLResponse';

type TopBannerReferenceConnection = NonNullable<
  GlobalNavigationContentEntry['top_banner_referenceConnection']
>;

export const adaptGraphQLTopBannerToCommon = (
  topBannerContent: TopBannerReferenceConnection,
): TopBannerMessage[] => {
  const adaptedTopBanners: TopBannerMessage[] = [];

  topBannerContent.edges.forEach((edge) => {
    const offerMessages = edge.node.offer_message;

    offerMessages.forEach((offerMessage) => {
      offerMessage.offer_message_referenceConnection.edges.forEach((offerMessageEdge) => {
        const offerMessageNode = offerMessageEdge.node;

        const adaptedTopBanner: TopBannerMessage = {
          backgroundColor: offerMessage.background_color,
          textColor: (offerMessage.text_color ?? 'Light') as 'Light' | 'Dark',
          message: offerMessageNode.message,
        };

        // Extract link URL if available
        const pageEdge = offerMessageNode.page_referenceConnection?.edges[0];
        if (pageEdge?.node.url) {
          adaptedTopBanner.linkUrl = pageEdge.node.url;
        }

        // Extract promo code if available
        const promoCodeModule = offerMessageNode.modular_content.find(
          (module) => 'promo_code' in module,
        ) as { promo_code: { promo_code: string } } | undefined;

        if (promoCodeModule) {
          adaptedTopBanner.promoCode = promoCodeModule.promo_code.promo_code;
        }

        // Extract countdown if available
        const countdownModule = offerMessageNode.modular_content.find(
          (module) => 'countdown' in module,
        ) as
          | {
              countdown: {
                end_date: string;
                message_when_countdown_shows: string;
                threshold: number;
              };
            }
          | undefined;

        if (countdownModule) {
          adaptedTopBanner.countdown = {
            endDate: countdownModule.countdown.end_date,
            message: countdownModule.countdown.message_when_countdown_shows,
            threshold: countdownModule.countdown.threshold,
          };
        }

        adaptedTopBanners.push(adaptedTopBanner);
      });
    });
  });
  return adaptedTopBanners;
};
